export default {
      id: "google-play-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#google-play",
      toString: function () {
        return this.url;
      }
    }